// extracted by mini-css-extract-plugin
export var hideEditor = "_i4-2";
export var infoIcon = "_i4-3";
export var label = "_i4-1";
export var labelContainer = "_i4-0";
export var readonlyText = "_i4-4";